import './DashboardHeader.css';

const DashboardHeaderMetric = ({ label, value, tone = 'neutral', variant = 'hero' }) => (
    <div className={`dashboard-metric-pill dashboard-metric-pill--${tone} ${variant === 'card' ? 'dashboard-metric-pill--card' : ''}`}>
        <span>{label}</span>
        <strong>{value}</strong>
    </div>
);

/**
 * Cabeçalho das telas de dashboard.
 *
 * `compact` reduz o cabeçalho a uma linha: título, indicadores e ação lado a lado. Usado
 * onde o conteúdo da tela é mais importante que a apresentação dela, para não gastar a
 * primeira dobra com texto institucional. `action` entrega o botão junto dos indicadores,
 * em vez de abrir uma faixa própria abaixo do cabeçalho.
 */
const DashboardHeader = ({ eyebrow, title, subtitle, metrics = [], action, compact = false, children, className = '' }) => (
    <section className={`dashboard-hero${compact ? ' dashboard-hero--compact' : ''} ${className}`.trim()}>
        <div className="dashboard-hero__topbar">
            <div className="dashboard-hero__identity">
                {eyebrow && <p className="dashboard-hero__eyebrow">{eyebrow}</p>}
                <h1 className="dashboard-hero__title">{title}</h1>
                {subtitle && <p className="dashboard-hero__subtitle">{subtitle}</p>}
            </div>

            {(metrics.length > 0 || action) && (
                <div className="dashboard-hero__meta">
                    {metrics.map((metric, index) => (
                        <DashboardHeaderMetric
                            key={metric.key || `${metric.label}-${index}`}
                            label={metric.label}
                            value={metric.value}
                            tone={metric.tone}
                        />
                    ))}
                    {action}
                </div>
            )}
        </div>

        {children && <div className="dashboard-filters">{children}</div>}
    </section>
);

export { DashboardHeaderMetric };
export default DashboardHeader;
